import { AdminUsersAtMikatanoIdQuery } from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

export const adminUsersAtMikatanoIDHandler =
  graphql.query<AdminUsersAtMikatanoIdQuery>(
    "adminUsersAtMikatanoID",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          adminUsersAtMikatanoID: {
            adminUsers: [
              {
                sub: "sub1",
                username: "username1",
                email: "username1@moneyforward.co.jp",
                lastName: "田中",
                lastNameKana: "タナカ",
                middleName: "ミドルネーム",
                middleNameKana: "ミドルネームカナ",
                firstName: "太郎",
                firstNameKana: "タロウ",
              },
              {
                sub: "sub2",
                username: "username2",
                email: "username2@moneyforward.co.jp",
                lastName: "山田",
                lastNameKana: "ヤマダ",
                middleName: "ミドルネーム",
                middleNameKana: "ミドルネームカナ",
                firstName: "次郎",
                firstNameKana: "ジロウ",
              },
              {
                sub: "sub3",
                username: "username3",
                email: "username3@moneyforward.co.jp",
                lastName: "橋本",
                lastNameKana: "ハシモト",
                middleName: "ミドルネーム",
                middleNameKana: "ミドルネームカナ",
                firstName: "三郎",
                firstNameKana: "サブロウ",
              },
              {
                sub: "sub4",
                username: "username4",
                email: "username4@moneyforward.co.jp",
                lastName: "鈴木",
                lastNameKana: "スズキ",
                middleName: "ミドルネーム",
                middleNameKana: "ミドルネームカナ",
                firstName: "四郎",
                firstNameKana: "シロウ",
              },
              {
                sub: "01469db6-7b03-49e3-9820-de9482f4fb6d",
                username: "username1",
                email: "username1@moneyforward.co.jp",
                lastName: "名字",
                lastNameKana: "ミョウジ",
                middleName: "ミドルネーム",
                middleNameKana: "ミドルネームカナ",
                firstName: "名前",
                firstNameKana: "ナマエ",
              },
              {
                sub: "4649f62d-e90c-4bce-9ec2-81c5e0e6920f",
                username: "username2",
                email: "username2@moneyforward.co.jp",
                lastName: "名字2",
                lastNameKana: "ユウ",
                middleName: "ミドルネーム2",
                middleNameKana: "ミドルネームカナ2",
                firstName: "名前2",
                firstNameKana: "ナマエ2",
              },
            ],
          },
        },
      });
    }
  );
